<template>
  <div class="box-item d-flex flex-row align-center justify-center pa-3 mt-3 custom-radius">
    <div class="d-flex flex-column align-center justify-center card-bord">
      <div class="d-flex container-clipBoard">
        <div>
          <p style="margin: 0; font-size: 16px; color: #6f6f6f">Código para Pagamento Multibanco</p>
          <div class="d-flex justify-space-around">
            <p style="margin: 0" class="font-weight-bold color-darkGray mr-2">
              Entidade: {{ entity }}
            </p>
            <p style="margin: 0" class="font-weight-bold color-darkGray">
              Referência: {{ reference }}
            </p>
          </div>
        </div>
        <div @click="copy" class="ml-12" style="cursor: pointer">
          <svg xmlns="http://www.w3.org/2000/svg" width="28.5" height="33" viewBox="0 0 28.5 33">
            <path
              id="Icon_material-content-copy"
              data-name="Icon material-content-copy"
              d="M24,1.5H6a3.009,3.009,0,0,0-3,3v21H6V4.5H24Zm4.5,6H12a3.009,3.009,0,0,0-3,3v21a3.009,3.009,0,0,0,3,3H28.5a3.009,3.009,0,0,0,3-3v-21A3.009,3.009,0,0,0,28.5,7.5Zm0,24H12v-21H28.5Z"
              transform="translate(-3 -1.5)"
              fill="#6f6f6f"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    entity: { type: String },
    reference: { type: String },
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    copy() {
      this.dialog = false;
      this.$emit('copy');
    },
  },
};
</script>

<style lang="scss" scoped>
.container-clipBoard {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px;
}
</style>
